export const getAccountAnalytics = async () => {
  const token = localStorage.getItem("spectraToken") || "";
  const res = await fetch(`${process.env.REACT_APP_API_URL}/api/broker/account`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!res.ok) {
    throw new Error(`Server error ${res.status}`);
  }

  return await res.json();
};
